import React from 'react'
import { Create } from 'react-admin'
import ClubForm from './ClubForm'
import Toolbar from '../../components/FormToolbar'
import { transformData } from '../utils/helpers'

const CreateClub = (props) => {
  return (
    <Create
      {...props}
      toolbar={<Toolbar />}
      title='Создание клуба'
      transform={transformData}
    >
      <ClubForm {...props} />
    </Create>
  )
}

export default CreateClub
